<template>
	<div class="card-list">
		<el-row v-if="dataList.length>0" :gutter="20">
			<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-for="i in dataList" :key="i.id">
				<div class="box-card" @click="toPathDetail(i.actCode,i.actType)" @mouseover="mouseover(i)" @mouseleave="mouseleave">
					<div class="box-img">
						<el-image fit="cover" class="fm-img" :src="i.faceAttaches ? i.faceAttaches[0].attachUrl :'./cover/5.png'" alt></el-image>
						<span class="desc" v-if="moduleType==='eduResearch'">{{i.getClassify1Desc}}{{'/'+i.getClassify2Desc}}</span>
						<span class="desc" v-if="moduleType==='train'">{{i.getClassify3Desc}}（{{
                i.actType == "extraTraining" ? "校外" : "校内"
              }}）</span>
					<span class="desc" v-if="moduleType==='topicResearch'">{{i.getClassify4Desc}}</span>
					<transition name="el-fade-in-linear" v-if="i.createBy===userInfo.userId || (userInfo.roleCodes && userInfo.roleCodes.split(',').includes('admin')) || (i.speakUserIds && i.speakUserIds.includes(userInfo.userId))">
						<i v-show="curIdHover===i" class="edit el-icon-edit" @click.stop="toPathEdit(i.actCode, i.actType)"></i>
					</transition>
					<transition name="el-fade-in-linear" v-if="i.createBy===userInfo.userId || (userInfo.roleCodes && userInfo.roleCodes.split(',').includes('admin'))">
						<i v-show="curIdHover===i" class="del el-icon-delete" @click.stop="delPop(i.id)"></i>
					</transition>
					</div>
					<h2>{{i.actTitle}}</h2>
					<div class="mx clearfix">
						<span class="ing">{{ i.activeStatus | activeStatusFil }}</span>
						<span class="end" v-if="moduleType!='topicResearch'">{{i.isMySign ? "已":"未"}}参与</span>
						<span class="fr num" v-if="moduleType!='topicResearch'">{{i.signTotalNum}}人参与</span>
					</div>
					<h3>时间：{{i.startDate}}~{{i.endDate}}</h3>
					<div class="tea-desc clearfix">
						<img :src="i.createLogo ? i.createLogo : defaultManPng" alt class="fl" />
						<span class="fl">{{i.createName}}</span>
						<span style="font-size:12px" class="fr">{{i.createSchool}}</span>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-empty class="empty" :image-size="210" v-else description="暂无更多..."></el-empty>
		<!-- 删除的对话框 -->
		<popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
	</div>
</template>
<script>
import PopupDel from "@/components/PopupDel.vue";
import { postData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
export default {
	props: {
		dataList: {
			type: Array,
			default: () => []
		},
		moduleType: "" //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究 moralResearch  德育
	},
	components: {
		PopupDel
	},
	computed: {
		...mapState(["userInfo"])
	},

	data() {
		return {
			delVisible: false,
			defaultManPng: require("@/assets/image/other/man_teacher.png"),
			curIdHover: "",
			curId: ""
		};
	},
	created() {
		//this.init();
	},
	methods: {
		mouseover(id) {
			this.curIdHover = id;
		},
    isAdmin() {
      return (
        this.userInfo.roleCodes && this.userInfo.roleCodes.split(',').includes("admin")
      );
    },

		mouseleave() {
			this.curIdHover = "";
		},
		toPathDetail(actCode, actType) {
      debugger;
			sessionStorage.setItem("actCode", actCode);
			if (this.moduleType == "eduResearch") {
				this.$router.push({
					name: "detailResearch"
				});
			} else if (this.moduleType == "train") {
        if (actType == "extraTraining") {
          this.$router.push({
            name: "detailTrain"
          });
        } else {
          this.$router.push({
            name: "detailTrain"
          });
        }
				// this.$router.push({
				// 	name: "detailTrain"
				// });
			} else if (this.moduleType == "topicResearch") {
				this.$router.push({
					name: "detailTopic"
				});
			} else if (this.moduleType == "moralResearch") {
				this.$router.push({
					name: "detailMoral"
				});
			}
		},
		toPathEdit(actCode, actType) {
			sessionStorage.setItem("actCode", actCode);
			if (this.moduleType == "eduResearch") {
				this.$router.push({
					name: "editResearch"
				});
			} else if (this.moduleType == "train") {
        if (actType == "extraTraining") {
          this.$router.push({
            name: "editExtraTraining"
          });
        } else {
          this.$router.push({
            name: "editTrain"
          });
        }

			} else if (this.moduleType == "topicResearch") {
				this.$router.push({
					name: "editTopic"
				});
			} else if (this.moduleType == "moralResearch") {
				this.$router.push({
					name: "editMoral"
				});
			}
		},
		delPop(id) {
			this.delVisible = true;
			this.curId = id;
		},
		// 删除弹框 关闭
		async closePopupDel(status) {
			try {
				if (status) {
					if (this.moduleType == "eduResearch") {
						await postData("/research/deleteActiveInfo", { id: this.curId });
					} else if (this.moduleType == "train") {
						await postData("/training/deleteActiveInfo", { id: this.curId });
					} else if (this.moduleType == "topicResearch") {
						await postData("/topic/deleteActiveInfo", { id: this.curId });
					}else if (this.moduleType == "moralResearch") {
						await postJson("/moral/deleteMoralActivityInfo", { id: this.curId,operatorId:this.userInfo.userId });
					}

					this.$message({
						message: "删除成功",
						type: "success",
						duration: 2000,
						offset: 150
					});
					this.delVisible = false;
					this.$emit("delSuccess");
				} else {
					this.delVisible = false;
				}
			} catch (err) {
				console.log("err", err);
			}
		}
	},
	watch: {}
};
</script>
<style lang="less" scoped>
.card-list {
	//   border: 1px solid #000;
	.el-col {
		margin-bottom: 15px;
		.box-card {
			width: 100%;
			cursor: pointer;
			background: #fff;
			border-radius: 15px;
			border: 1px solid rgba(182, 179, 179, 0.5);
			.box-img {
				position: relative;
				top: 0px;
				left: 0px;
				.fm-img {
					height: 160px;
					width: 100%;
					border-top-left-radius: 15px;
					border-top-right-radius: 15px;

				}
				.desc {
					position: absolute;
					left: -5px;
					top: 40px;
					background: #ffc12c;
					padding: 5px 13px;
					color: #fff;
					border-bottom-right-radius: 10px;
					border-top-right-radius: 10px;
				}
				i {
					position: absolute;
					top: 12px;
					font-size: 14.5px;
					color: rgb(214, 214, 214);
					padding: 4px;
					border-radius: 50%;
					background-color: @hui;
				}
				.edit {
					right: 15px;
				}
				.edit:hover {
					color: @color;
				}
				.del {
					right: 43px;
				}
				.del:hover {
					color: @color;
				}
			}
		h2 {
			font-size: 14px;
			margin-left: 8px;
			color: #333;
			line-height: 30px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
			.mx {
				padding: 1px 8px;
				span {
					color: #fff;
					margin-right: 10px;
					padding: 3px 7px;
					border-radius: 7px;
				}
				.ing {
					background: @color;
				}
				.end {
					background: @hui;
				}
				.num {
					color: rgb(155, 154, 154);
				}
			}
			h3 {
				font-size: 12px;
				margin-left: 8px;
				color: @hui;
				line-height: 22px;
			}
			.tea-desc {
				border-top: 1.5px solid #eee;
				padding: 6px 20px;
				img {
					width: 25px;
					height: 25px;
					border-radius: 50%;
					border: 1px solid #eee;
				}
				span {
					margin-top: 4px;
					margin-left: 6px;
					font-size: 14px;
				}
			}
		}
	}
	.empty{
		width: 210px;
		margin: 0 auto;
		text-align: center;
		font-size: 14px;

	}
}
</style>
